import { useEffect, useState } from 'react';

/**
 * Первое появление интерфейса: `true`, пока данные не готовы (`ready`), и ещё `durationMs` после — столько длится
 * анимация появления. Последующие обновления данных его не повторяют. Оболочка (`AppShell`, `SidebarMenu`) и
 * страницы приложений с анимацией первого показа.
 */
export const useInitialReveal = (ready = true, durationMs = 500) => {
    const [isRevealing, setIsRevealing] = useState(true);

    useEffect(() => {
        if (!ready || !isRevealing) return;

        const timer = window.setTimeout(() => setIsRevealing(false), durationMs);
        return () => window.clearTimeout(timer);
    }, [ready, isRevealing, durationMs]);

    return isRevealing;
};
